/* eslint-disable object-shorthand */
import type { CustomerType } from 'features/BannerAndTicker/redux/banner/bannerSlice'
import type {
  RefferalOptionType,
  RefferalCustomerType,
  RefferalCustomerQueryType,
  RefferalSettingType,
  RefferalSettingPayloadType,
} from 'utils/api'
import type {
  RefferalStateType,
  RefferalPaginationType,
  RefferalActionType,
} from 'storeContext/reducers/referral/types'

import {
  SET_IS_LOADING,
  SET_BENEFITS,
  SET_TARGETS,
  SET_MECHANISMS,
  SET_USERLIST,
  SET_IS_LOADING_GET_USER,
  SET_DATA_PAGINATION_USER,
  SET_SELECTED_CUSTOMERS,
  SET_DATA_REFFERAL,
} from 'storeContext/actionsType/refferal'

import {
  getBenefits,
  getTargets,
  getMechanisms,
  getCustomer,
  getRefferalSettingBuyer,
  putRefferalSettingBuyer,
  postUploadedTargettedUSer,
} from 'utils/api'

import { toastFailed, toastSuccess } from 'utils/toast'

export type RefferalGetStateType = () => { stateRefferal: RefferalStateType }
export type RefferalThunkType = (
  dispatch: RefferalDispatchType,
  getState: RefferalGetStateType,
) => void
export type RefferalDispatchType = (action: RefferalActionType | RefferalThunkType) => void

export function setDataRefferal(payload: RefferalSettingType): RefferalActionType {
  return {
    type: SET_DATA_REFFERAL,
    payload: payload,
  }
}

export function setSelectedCustomers(payload: RefferalCustomerType[]): RefferalActionType {
  return {
    type: SET_SELECTED_CUSTOMERS,
    payload: payload,
  }
}
export function setIsLoadingGetUser(payload: boolean): RefferalActionType {
  return {
    type: SET_IS_LOADING_GET_USER,
    payload: payload,
  }
}
export function setDataPaginationUser(payload: RefferalPaginationType): RefferalActionType {
  return {
    type: SET_DATA_PAGINATION_USER,
    payload: payload,
  }
}

export function setIsLoading(payload: boolean): RefferalActionType {
  return {
    type: SET_IS_LOADING,
    payload: payload,
  }
}

export function setBenefits(payload: RefferalOptionType[]): RefferalActionType {
  return {
    type: SET_BENEFITS,
    payload: payload,
  }
}

export function setTargets(payload: RefferalOptionType[]): RefferalActionType {
  return {
    type: SET_TARGETS,
    payload: payload,
  }
}

export function setMechanisms(payload: RefferalOptionType[]): RefferalActionType {
  return {
    type: SET_MECHANISMS,
    payload: payload,
  }
}

export function setUserList(payload: RefferalCustomerType[]): RefferalActionType {
  return {
    type: SET_USERLIST,
    payload: payload,
  }
}

export const actGetDropDownList = () => (dispatch: RefferalDispatchType) => {
  dispatch(setIsLoading(true))
  const arrPending = [getBenefits(), getTargets(), getMechanisms()]
  Promise.all(arrPending)
    .then(([{ data: benefitsData }, { data: targetsData }, { data: mechanismsData }]) => {
      dispatch(setBenefits(benefitsData))
      dispatch(setTargets(targetsData))
      dispatch(setMechanisms(mechanismsData))
    })
    .finally(() => {
      dispatch(setIsLoading(false))
    })
}

export const setFindUser =
  (query: RefferalCustomerQueryType = {}, isNextPage = false) =>
  (dispatch: RefferalDispatchType, getState: RefferalGetStateType) => {
    dispatch(setIsLoadingGetUser(true))
    getCustomer({ ...query, newBuyer: true })
      .then(({ data }) => {
        // eslint-disable-next-line arrow-body-style
        let dataCustomer: RefferalCustomerType[] = data.content.map((el) => {
          return {
            ...el,
            name: `${el.customer_phone_number} ${el.customer_name ? '-' : ''} ${
              el.customer_name || ''
            }`,
          }
        })
        if (isNextPage) {
          const { userList } = getState().stateRefferal
          dataCustomer = [...userList, ...dataCustomer]
        }
        const pagination = {
          pageSize: data.size,
          totalData: data.totalElements,
          totalPage: data.totalPages,
          currentPage: data.number,
          currentItem: data.numberOfElements,
          lastParams: query,
        }
        dispatch(setDataPaginationUser(pagination))
        dispatch(setUserList(dataCustomer))
      })
      .finally(() => {
        dispatch(setIsLoadingGetUser(false))
      })
  }

export const actHandleAddCustomer =
  (option: RefferalCustomerType) =>
  (dispatch: RefferalDispatchType, getState: RefferalGetStateType) => {
    const { userList, listSelectedCustomers } = getState().stateRefferal
    dispatch(setSelectedCustomers([...listSelectedCustomers, option]))
    const filtedUser = userList.filter((el) => el.customer_id !== option.customer_id)
    dispatch(setUserList(filtedUser))
  }

export const actHandleRemoveCustomer =
  (option: RefferalCustomerType) =>
  (dispatch: RefferalDispatchType, getState: RefferalGetStateType) => {
    const { userList, listSelectedCustomers } = getState().stateRefferal
    dispatch(setUserList([...userList, option]))
    const filtedUser = listSelectedCustomers.filter((el) => el.customer_id !== option.customer_id)
    dispatch(setSelectedCustomers([...filtedUser]))
  }

export const actGetRefferalData =
  () => (dispatch: RefferalDispatchType, _getState: RefferalGetStateType) => {
    dispatch(setIsLoading(true))
    getRefferalSettingBuyer()
      .then(({ data }) => {
        dispatch(setDataRefferal(data))
      })
      .finally(() => {
        dispatch(setIsLoading(false))
      })
  }

export const actSubmitRefferal =
  (payload: RefferalSettingPayloadType) =>
  (dispatch: RefferalDispatchType, getState: RefferalGetStateType) => {
    const { dataRefferal } = getState().stateRefferal
    dispatch(setIsLoading(true))
    // TODO(WP-4344): Legacy submit can receive an unset ID before settings load.
    putRefferalSettingBuyer(dataRefferal.id!, payload)
      .then(({ data }) => {
        toastSuccess('Update berhasil')
        dispatch(setDataRefferal(data))
      })
      .catch(() => {
        toastFailed('Update gagal')
      })
      .finally(() => {
        dispatch(setIsLoading(false))
      })
  }

export const actUploadCsv =
  (
    payload: FormData,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    cb: (data: CustomerType[]) => void = () => {},
  ) =>
  (dispatch: RefferalDispatchType) => {
    dispatch(setIsLoading(true))
    postUploadedTargettedUSer(payload)
      .then(({ data }) => {
        cb(data)
      })
      .catch(() => {
        toastFailed('Upload user gagal')
      })
      .finally(() => {
        dispatch(setIsLoading(false))
      })
  }
